import { inject, Injectable } from '@angular/core';
import { adminUserApi, adminUserDtos } from '@vectronic/openApi-admin';
import { IDatatableColumnStorageService } from '@vectronic/table';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AdminDatatableColumnStorageService implements IDatatableColumnStorageService {
  private api = inject(adminUserApi.DatatableSettings);

  get(tableId: string): Observable<adminUserDtos.DatatableSettings> {
    return this.api.getSettings(tableId);
  }

  set(tableId: string, data: adminUserDtos.DatatableSettings): Observable<void> {
    return this.api.persistSettings(tableId, data);
  }
}
